import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=ccffe16e&scoped=true&"
import script from "./Advantages.vue?vue&type=script&lang=js&"
export * from "./Advantages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccffe16e",
  null
  
)

export default component.exports